function call_resize() {
  if (typeof resize === "function")
    resize();
}

document.addEventListener("DOMContentLoaded", function () {
  let $payment_gateway = document.getElementById("payment_gateway");



  function setPriceFromPaymentGateway($payment_gateway)
  {
    let $price = document.querySelector(".form__price_value");
    $price.innerText = $payment_gateway.options[$payment_gateway.selectedIndex].dataset.rub;
  }
  if ($payment_gateway) {
    $payment_gateway.addEventListener("change", e => setPriceFromPaymentGateway(e.target));
    setPriceFromPaymentGateway($payment_gateway);
  }


  document.querySelectorAll('form').forEach(form => {

    form.addEventListener("submit", function (e) {

      if (document.getElementById('agreement').checked == false) {
        var al = document.getElementById('al');
        al.classList.add('err');
        setTimeout(function () {
          al.classList.remove('err');
        }, 2000)

        e.preventDefault();
        return false;
      }
    })
  });
});

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined
}

// function getCookie(name) {
//   let matches = document.cookie.match(new RegExp(
//     "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
//   ));
//   return matches ? decodeURIComponent(matches[1]) : undefined;
// }
//
// window.getCookie = getCookie;
